import GameiomModel from "gameiom/model/gameiom-model";
import Layers from "slotworks/graphics/layers/layers";
import MaxBetButtonControl from "slotworks/smart-ui/controls/button/max-bet-button-control";
import HeadlessSmartUIGroup from "slotworks/smart-ui/smart-ui-group";

export default class AgsMaxBetButtonControl extends MaxBetButtonControl {

    private maxBet: any;
    private maxBetLabel: PIXI.Text;

    public setup(name: string, layer: Layers, assetName: string, assetNames: string[], smartUIGroup: HeadlessSmartUIGroup) {
        super.setup(name, layer, assetName, assetNames, smartUIGroup);

        this.maxBet = this.layer.getButton(assetName);
        this.maxBetLabel = (this.maxBet) ? this.maxBet.getChildByName(`lbl-${assetName}`) : null;

        if (GameiomModel.displayMaxBet === false) {
            this.hideMaxBetIfDisabled();
            this.setEnabled(GameiomModel.displayMaxBet);
        }
    }

    public setEnabled(enabled: boolean) {
        if (GameiomModel.displayMaxBet === false) {
            enabled = false;
            this.hideMaxBetIfDisabled();
        }
        super.setEnabled(enabled);
    }
    private hideMaxBetIfDisabled() {
        // Hide Max Bet text if it's diabled from the wrapper
        if (GameiomModel.displayMaxBet === false && this.maxBetLabel) {
            this.maxBetLabel.visible = false;
        }
    }

}
